import { styled } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import { Input } from "../../../../../../components/Form";

export const MainDiv = styled("div")(() => ({
  minHeight: "inherit",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "& .MuiTableContainer-root": {
    overflowY: "hidden",
  },
}));

export const RowInputDiv = styled("div")(() => ({
  width: "100%",
}));

export const NumberRowInput = styled(Input)(() => ({
  maxWidth: "120px",
  "& .MuiOutlinedInput-root": {
    height: "32px",
  },
}));

const styles = makeStyles(() => ({
  tooltipError: {
    color: "#B42318 !important",
    backgroundColor: "#FEE4E2 !important",
  },
}));

export default styles;
